export enum EasyDgdStep {
  TransportMode = 0,
  GeneralInformation = 1,
  PackingList = 2,
  Preview = 3,
  Download = 4,
}
